import React, {
    cloneElement,
    isValidElement,
    ReactNode,
    useMemo,
    useId,
    useState,
} from 'react';
import { InfoRoundedIcon } from '../../assets/icons';
import { Tooltip, ITooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import Portal from '../Portal';
import clsx from 'clsx';

type InfoPopUpProp = {
    children: ReactNode;
    trigger?: ReactNode;
    className?: string;
} & Exclude<ITooltip, 'anchorId' | 'isOpen' | 'setIsOpen' | 'className'>;

const InfoPopUp: React.FC<InfoPopUpProp> = ({
    className = '',
    children,
    trigger,
    ...rest
}) => {
    const uuid = useId();

    const [isOpen, setIsOpen] = useState(false);

    const clonedIcon = useMemo(
        () =>
            isValidElement(trigger)
                ? cloneElement(trigger, {
                      // @ts-ignore
                      'data-tooltip-id': uuid,
                      id: uuid,
                  })
                : undefined,
        [trigger, uuid]
    );

    return (
        <div className='info-container'>
            <Portal>
                <Tooltip
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    id={uuid}
                    className={clsx('info-pop-up', className)}
                    {...rest}
                >
                    {isOpen ? children : null}
                </Tooltip>
            </Portal>
            {clonedIcon ?? <InfoRoundedIcon data-tooltip-id={uuid} />}
        </div>
    );
};

export default InfoPopUp;
